import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LegalTabs } from "@/components/legal/LegalTabs";

export default function LegalPage() {
  const { key } = useParams();
  const navigate = useNavigate();
  const current = key || "mentions_legales";
  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <header className="border-b border-[#DEE2E6] bg-white print:hidden">
        <div className="max-w-[1200px] mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/pag-logo.png" alt="PAG" className="h-9 w-9" />
            <span className="font-display font-black text-lg">PAG</span>
            <span className="text-xs uppercase tracking-[0.25em] text-[#868E96] border-l border-[#DEE2E6] pl-3">Informations légales</span>
          </Link>
          <Link to="/" className="text-sm font-semibold flex items-center gap-2 hover:text-[#002FA7]" data-testid="legal-back-home"><ArrowLeft className="h-4 w-4" />Accueil</Link>
        </div>
      </header>
      <main className="max-w-[1200px] mx-auto px-6 py-10 lg:py-14" data-testid="legal-page">
        <div className="text-xs uppercase tracking-[0.3em] text-[#868E96] font-semibold mb-3 print:hidden">// Transparence</div>
        <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tighter mb-8 print:hidden">Informations légales</h1>
        <LegalTabs current={current} onChange={(k) => navigate(`/legal/${k}`)} />
      </main>
    </div>
  );
}
